import { useState } from "react";
import { faqs } from "@/mocks/chigua";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-24">
              <div className="flex items-center gap-2 text-primary-600 text-sm font-medium mb-2">
                <span className="w-8 h-0.5 bg-primary-500 rounded-full"></span>
                常见问题
              </div>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-snug">
                你可能想知道的
              </h2>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                关于信息真实性、事件处理原则与读者参与方式,我们把最常见的疑问集中说明。
              </p>
              <a
                href="#subscribe"
                className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
              >
                还有疑问?联系我们
                <i className="ri-mail-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-8 space-y-3">
            {faqs.map((item, i) => {
              const isOpen = openIdx === i;
              return (
                <div
                  key={item.q}
                  className={
                    "rounded-xl border transition-colors " +
                    (isOpen
                      ? "bg-background-50 border-background-300"
                      : "bg-background-50/60 border-background-200 hover:border-background-300")
                  }
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(isOpen ? null : i)}
                    className="w-full flex items-center justify-between gap-4 p-5 text-left"
                    aria-expanded={isOpen}
                  >
                    <span className="flex items-center gap-3">
                      <span
                        className={
                          "flex-shrink-0 w-7 h-7 rounded-md flex items-center justify-center text-xs font-medium " +
                          (isOpen
                            ? "bg-accent-500 text-background-50"
                            : "bg-accent-100 text-accent-800")
                        }
                      >
                        Q{i + 1}
                      </span>
                      <span className="font-heading text-sm md:text-base font-bold text-foreground-900 leading-snug">
                        {item.q}
                      </span>
                    </span>
                    <i
                      className={
                        "flex-shrink-0 ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 " +
                        (isOpen ? "rotate-180" : "")
                      }
                      aria-hidden="true"
                    ></i>
                  </button>
                  <div
                    className={
                      "grid transition-all duration-300 ease-in-out " +
                      (isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0")
                    }
                  >
                    <div className="overflow-hidden">
                      <div className="px-5 pb-5 pl-[60px]">
                        <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}